import { useEffect, useState } from "react";
import { MapPinned } from "lucide-react";
import api, { API } from "../lib/api";
import MapView from "./MapView";

/* Community photos with GPS tags pinned on the destination guide map. */
export default function GuidePhotoMap({ slug, name, accent = "#1a73e8" }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/community/photo-map?slug=${encodeURIComponent(slug)}`)
      .then((r) => setData(r.data)).catch(() => setData({ center: null, photos: [] }));
  }, [slug]);

  if (!data || !data.center) return null;
  const markers = data.photos.map((p) => ({
    lat: p.lat, lon: p.lon, radius: 8, color: "#f59e0b",
    popup: (
      <div className="w-44" data-testid={`photo-pin-${p.id}`}>
        <img src={`${API}${p.url.replace(/^\/api/, "")}`} alt={p.caption || "traveler photo"}
          className="w-full h-24 object-cover mb-1.5" loading="lazy" />
        {p.caption && <div className="font-bold text-xs leading-tight">{p.caption}</div>}
        <div className="text-[11px] text-zinc-500">
          {p.place && <span>{p.place} · </span>}by {p.user_name || "a traveler"}
        </div>
      </div>
    ),
  }));

  return (
    <section className="mb-8" data-testid="guide-photo-map">
      <h2 className="font-heading font-900 text-2xl border-b-2 pb-2 mb-3 flex items-center gap-2"
        style={{ borderColor: accent }}>
        <MapPinned className="w-6 h-6" style={{ color: accent }} /> Traveler Photo Map
      </h2>
      <MapView center={[data.center.lat, data.center.lon]} zoom={markers.length ? 9 : 8}
        markers={markers} origin={{ center: [data.center.lat, data.center.lon], label: name }}
        height="380px" />
      <p className="text-xs text-muted-foreground mt-2" data-testid="guide-photo-map-note">
        {markers.length
          ? `${markers.length} community photo${markers.length === 1 ? "" : "s"} pinned from GPS location tags.`
          : "No GPS-tagged traveler photos yet — upload a photo with location data in the community section below and it will appear here."}
      </p>
    </section>
  );
}
